import { set } from 'immutadot'
import {
    CLOSE_SOCIAL_SHARING,
    OPEN_SOCIAL_SHARING,
} from './actions'

const initialState = {
    isOpened: false,
}

export const share = (state = initialState, { type }) => {
    switch(type) {
        case OPEN_SOCIAL_SHARING:
            return set(state, 'isOpened', true)

        case CLOSE_SOCIAL_SHARING:
            return set(state, 'isOpened', false)

        default:
            return state
    }
}
